import { Attachment, Button, DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutImportFile extends Layout {
    attachmentFile: Attachment;
    buttonBrowseFiles: Button;
    sourceImportFile: DataSource;
    switchBeginningBalance: Switch;
    switchDeleteExistingTimecards: Switch;
    switchMatchOnPrevCode: Switch;
    textboxActionType: Textbox;
    textboxEndRow: Textbox;
    textboxFileName: Textbox;
    textboxId: Textbox;
    textboxStartRow: Textbox;
    textboxTransactionDate: Textbox;
    textboxWorksheet: Textbox;
}
